let _this;
export default {
  name: "same-user-detected",
  props:['userInfo','userType','userACData','tempAccessData','userId','fastInfo'],
  data(){
    return{
      idSearchModal:false,
      enablePDPA:this.ApiService.identityInfo.isEnablePDPA,/*是否启用PDPA*/
      keepFigures:this.ApiService.identityInfo.keepFigures,/*ID保留位数*/
      sameIdList:[],/*共同ID集合*/
      replaceInfo:{},
      replaceTipModal:false
    }
  },
  mounted(){
    _this = this;
  },
  methods:{
    // ID检索
    sameIdSearch:function () {
      _this.userInfo.addIdentityCards[0].no = _this.userInfo.addIdentityCards[0].no.replace(/[\W]|_/g,'');
      let cardNo = _this.userInfo.addIdentityCards[0].no;
      _this.userInfo.addIdentityCards[0].no = cardNo;
      if((!_this.enablePDPA && cardNo) || (_this.enablePDPA && (cardNo.length >= _this.keepFigures))){
        let params = {
          exactMatchIdentityCard:true,
          enabledPaging:true,
          page:1,
          perPage:500,
          identityCardNo:cardNo,
          userTypes:[this.userType]
        };
        this.$ajax.post('User/Paging',params,{headers:{noLoading:true}}).then(function (res) {
          if(res.data.success ){
            _this.sameIdList = res.data.data ? res.data.data.items : [];
            // // 移除当前用户
            _this.sameIdList.forEach(item =>{
              if(item.faceFileId){
                _this.shareApi.getImgUrl(item.faceFileId).done(imgUrl =>{
                  _this.$set(item,'imgUrl',imgUrl);
                })
              }
              if(item.profilePhotoFileId){
                _this.shareApi.getImgUrl(item.profilePhotoFileId).done(imgUrl =>{
                  _this.$set(item,'imgUrlPro',imgUrl);
                })
              }
            });
            if(_this.sameIdList.length > 0){
              _this.idSearchModal = true;
            }
            _this.$emit('getSameUserCount',_this.sameIdList.length)
          }else{
            _this.messageNotice('error',res.data.message);
          }
        })
      }
    },
    // 展开相同内容
    expandContent:function (e) {
      $(e.target).parents('.details-box-option').find('.details-module-content').slideToggle(300);
      $(e.target).parents('.details-box-option').find('.ivu-icon-ios-arrow-up').toggleClass('rotate');
    },
    // 信息替换
    uploadInfo:function (user) {
      this.replaceInfo = user;
      let userUpdateInfo = this.userInfo;
      userUpdateInfo.customFields = _this.customFields;
      userUpdateInfo.userACData = _this.userACData;
      userUpdateInfo.tempAccessData = _this.tempAccessData;
      userUpdateInfo.departmentName = _this.userInfo.department;
      if(this.userId){
        userUpdateInfo.userId = this.userId;
      }
      localStorage.setItem('userUpdateInfo',JSON.stringify(userUpdateInfo));
      this.replaceTipModal = true;
    },
    // 确认替换
    confirmReplace:function () {
      let path = {'0':'editStaff','1':'editVisitor','2':'editVendor','3':'editTenant'};
      if(this.fastInfo && this.fastInfo.isfast){
        _this.idSearchModal = false;
        _this.replaceTipModal = false;
        eventBus.$emit('closeModel');
        _this.$router.push({path:path[this.fastInfo.type],query:{userId:this.replaceInfo.id,repFlag:true}});
      }else{
        _this.$router.push({path:path[this.userType],query:{userId:this.replaceInfo.id,repFlag:true}});
        if(_this.$route.query.userId){
          _this.$router.go(0);
        }
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/fastRegistration/fastSameUserDetected.js